module.exports = __webpack_public_path__ + "img/HTCC-AB02A.bc09cf14.jpg";